import { compare } from 'compare-versions';
import { isFunction } from 'lodash-es';
import chatttSDK, { chatttSDKChannel } from './sdk';

export * from './channels/const';
export { hidePayment } from './channels/features';

export default chatttSDK;

export const syncSysSettings = (settings: Chattt.SystemSettings) => {
  if (chatttSDK?.syncSysSettings) {
    chatttSDK.syncSysSettings(settings);
  }
};
export const isMlj = chatttSDKChannel === 'SELF_EMALACCA' || chatttSDKChannel === 'EMALACCA';

export const canMultiAuth = typeof chatttSDK?.shopee?.multiAuth === 'function';

export const getVersion = () => {
  if (typeof chatttSDK?.app?.getVersionSync === 'function') {
    return chatttSDK.app.getVersionSync();
  }
  return localStorage.getItem('chatppVer') || '';
};

const version = getVersion();

const enable = !!chatttSDK && !!version;

export const canMoveDatabase =
  enable && compare(version, '1.10', '>=') && compare(version, '2.6', '<');

export const canChkPageTrans = enable && compare(version, '2.3.4', '>=');

export const canZoomView = enable && compare(version, '2.4.0', '>=');

export const canNetScan = enable && compare(version, '2.5.0', '>=');

export const canBrowserSetting = enable && compare(version, '2.12.0', '>=');

// @ts-ignore
export const isTokoBridgeCallApiSupported = enable && isFunction(chatttSDK?.tokoBridge?.callApi);

export const localeCountryCode = chatttSDK?.app?.getLocaleCountryCode
  ? chatttSDK.app.getLocaleCountryCode()
  : '';

// 是否是印尼地区
export const isInID = localeCountryCode.toLowerCase() === 'id';

export const multiAuthSupportSelectDepartment = !!(enable && compare(version, '2.13.0', '>='));
